module.exports = __webpack_public_path__ + "img/usa.c366caef.png";